module.exports = __webpack_public_path__ + "static/media/bestteam.93ad6b43.JPG";